<div class="list">
  <div class="actions">
    <a [gmtAuth]="'manage_opinions'" uiSref="symap.project.opinionRequests.create" class="button">
      <i class="fa fa-plus-square"></i>Založit záznam o zpracování ZP
    </a>

    <a [gmtAuth]="'manage_opinions'" uiSref="symap.project.opinionRequests.fillPricesForm" class="button">
      <i class="fa fa-plus-square"></i>Vložit vyhotovený ZP
    </a>
  </div>

  <h1>Znalecké posudky</h1>
  <filter [list]="list" (onChanged)="pageableList.onFilterChanged($event)">

    <!-- katastralni uzemi -->
    <gmt-select
      resource="areas"
      [filter]="{ sortOrder: { sortBy: 'name' }}"
      [data]="list.filter.filters.areaId"
      field="values"
      [multiselect]="true"
      selectTitle="Katastrální území"
    ></gmt-select>

    <!-- stav ze -->
    <gmt-select
      [optionItems]="statusOptions"
      [data]="list.filter.filters.status"
      field="values"
      [multiselect]="true"
      selectTitle="Stav ZE"
    ></gmt-select>

    <!-- LV -->
    <gmt-select
      resource="titles"
      [data]="list.filter.filters.titleId"
      field="values"
      [multiselect]="true"
      [itemPipe]="titleNamePipe"
      selectTitle="LV"
    ></gmt-select>

    <!-- parcely -->
    <gmt-select
      resource="parcels"
      [filter]="{ filters: { validity: 'valid' }}"
      [data]="list.filter.filters.parcelId"
      field="values"
      [multiselect]="true"
      [itemPipe]="parcelNumberPipe"
      selectTitle="Parcela"
    ></gmt-select>

    <!-- Znalci -->
    <gmt-select
      resource="experts"
      [data]="list.filter.filters.expertId"
      field="values"
      [multiselect]="true"
      [itemPipe]="subjectNamePipe"
      selectTitle="Znalec"
    ></gmt-select>

    <div class="tag" [ngClass]="{ active: !list.filter.filters.deleted.values.length }" title="Zobrazení vč. ZP, které jsou smazané" (click)="onToggleDeleted()">
      <div>Zobrazit zrušené ZP</div>
    </div>

    <div>
      <input class="fulltext" type="text" placeholder="Fultextové hledání..." [(ngModel)]="list.filter.filters.searchText.values[0].id"/>
    </div>
  </filter>

  <div [loading]="list.loading || !settingsLoaded">
    <div class="table-top-container">
      <div class="flex1"><gmt-button [clickAction]="onExport" [gmtDisabled]="!exportEnable"><i class="fa fa-download"></i> Exportovat seznam</gmt-button></div>
      <pagescounter *ngIf="list.itemCount && settingsLoaded && list.list !== null" [list]="list" (callbackRegister)="pageableList.pagescounterCallbackRegister($event)"></pagescounter>
      <div class="page-count-select" *ngIf="list.itemCount && settingsLoaded && list.list !== null">
        <span>Záznamů na stránce</span>
        <gmt-select required="true" [data]="pageableList.dataPaging" field="itemsPerPage" [optionItems]="pageableList.itemsPerPageItems" (changed)="pageableList.changePageItems()" class="min-width-unset"></gmt-select>
      </div>
    </div>

    <table-opinion-request [list]="list" (sort)="pageableList.onSort($event.column, $event.ascOrDesc)" *ngIf="settingsLoaded"></table-opinion-request>

    <div class="empty-info bordered pb-20 pt-20 centered-text" *ngIf="!list.itemCount && list.list !== null && !list.loading">
      <span>Nebyla nalezena žádná data.</span>
    </div>
  </div>

  <itemscounter
    *ngIf="list.itemCount && list.list !== null" [list]="list"
    (callbackRegister)="pageableList.itemcounterCallbackRegister($event)"
    style="max-width: 100px;"
  ></itemscounter>

  <pagination
    *ngIf="list.itemCount && list.list !== null"
    [list]="list"
    (callbackRegister)="pageableList.paginationCallbackRegister($event)"
  ></pagination>

  <help [helpId]="helpIds.OPINION_REQUEST_LIST" class="cm-help-page"></help>
</div>
